import { MenuDropdown } from '@widgets/events/dropdown-menu';
import { MoreHoriz } from '@shared/assets';
import { IconButton, MenuItem } from '@shared/ui';
import { useMenu } from 'library/hooks/events';
import type { Event } from 'library/models/events';

type IconButtonVariant =
  | 'outlined'
  | 'dark'
  | 'transparent'
  | 'active'
  | 'light'
  | 'secondary'
  | 'mobile'
  | 'white';
interface Props {
  event: Event;
  variant?: IconButtonVariant;
  hasTickets: boolean;
}

export const Menu = ({ event, variant = 'transparent', hasTickets }: Props): JSX.Element => {
  const { items, onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useMenu({
    event,
    hasTickets,
  });

  const handleClickItem = (e: React.MouseEvent<HTMLElement, MouseEvent>, action: () => void) => {
    action();
    onClose(e);
  };

  return (
    <>
      <IconButton
        variant={variant}
        id="menu-button"
        onClick={onOpen}
        ref={(ref) => setReferenceEl(ref)}
      >
        <MoreHoriz />
      </IconButton>
      <MenuDropdown
        referenceEl={referenceEl}
        popperEl={popperEl}
        setPopperEl={setPopperEl}
        offset={[0, 0]}
      >
        {items.map((item) => (
          <MenuItem key={item.title} onClick={(e) => handleClickItem(e, item.action)}>
            {item.title}
          </MenuItem>
        ))}
      </MenuDropdown>
    </>
  );
};
